import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import store from '../../Redux/Store';
// import { showAlert } from '../../Redux/Slices/Pages/Client/Ui/Ui';

export const showNotification = (toastProps) => {
  const {
    message = "",
    type = "info", // info, error, success, warn
    theme = "light",
    autoClose = true,
  } = toastProps;

  // ✅ Safety: Ensure message is always a string to prevent .toLowerCase() crashes
  const safeMessage = typeof message === 'string' ? message : (message?.message || String(message || ""));

  // 🛡️ CTO SMART FILTER: Silencing "Noise" notifications (Instagram Style)
  // We hide common successes because the screen transition is enough feedback.
  const msgLower = safeMessage.toLowerCase();
  const isCommonSuccess = (type === 'success' || type === 'info') && (
    msgLower.includes("login") || 
    msgLower.includes("otp") || 
    msgLower.includes("logout") || 
    msgLower.includes("verified") ||
    (msgLower.includes("success") && !msgLower.includes("payment") && !msgLower.includes("booking"))
  );

  if (isCommonSuccess) {
    return; // Silent transition
  }

  // ✅ Premium Feedback System (Unified for Mobile/TWA/Desktop)
  window.dispatchEvent(new CustomEvent('BZ_SHOW_FEEDBACK', {
    detail: {
      message: safeMessage,
      type: type === 'warn' ? 'warning' : type,
      duration: autoClose ? 4000 : 8000,
    }
  }));

  // ✅ Legacy Desktop standard toasts (optional, keeping for safety if container exists)
  const toastOptions = {
    theme: theme === "coloured" ? "colored" : (theme === "dark" ? "dark" : "light"),
  };

  switch (type) {
    case "info":
      toast.info(safeMessage, toastOptions);
      break;
    case "error":
      toast.error(safeMessage, toastOptions);
      break;
    case "success":
      toast.success(safeMessage, toastOptions);
      break;
    case "warn":
      toast.warn(safeMessage, toastOptions);
      break;
    default:
      toast(safeMessage, toastOptions);
  }
};
